import type { AllRouteEndpoints } from "../routeTypes";

export const apiCalculatedAttributesIdAppGroupId = "/api/calculated_attributes/:id/:app_group_id";

export const putApiCalculatedAttributesIdAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  "/api/calculated_attributes/:app_group_id",
  "/api/calculated_attributes/:id/:app_group_id",
];
